import React from 'react';
import InfoTooltip from './ToolTip';
import ToolTipIcon from './ToolTipIcon';
import { formatCurrency } from '../../helpers/currencies';
const ProductSelectGrid = ({ selected, buttons, selectNewPart }) => {
    return (React.createElement("div", { className: `product-select` }, buttons.map((btn, index) => (React.createElement("div", { key: index, className: "product-select__button-wrapper" },
        React.createElement("button", { className: `product-select__button ${selected == btn.part_type ? 'product-select__button--selected' : ''} ${btn.out_of_stock ? 'product-select__button--oos' : ''}`, key: `part-select--${index}`, onClick: () => selectNewPart(btn.component, btn.part_type, btn.prodIndex) },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: btn.svg_icon } }),
            btn.title,
            btn.surcharge != 0 ? React.createElement("div", { className: `price-tag ${selected == btn.part_type ? 'price-tag--active' : ''}` },
                "+",
                formatCurrency(btn.surcharge * 100)) : null),
        btn.tooltip && (React.createElement(InfoTooltip, { title: btn.tooltip },
            React.createElement("div", { className: "tooltip-trigger" },
                React.createElement(ToolTipIcon, null)))))))));
};
export default ProductSelectGrid;
